<template>
  <div class="w-full overflow-auto p10">
    <div class="w-full non-mobile-class">
      <div class="w-full flex-row mb16 text-bold text-14">
        <div class="column40">
          Kegiatan
        </div>
        <div class="column40">
          Area Kerja
        </div>
        <div class="column10 cursor-pointer" @click="sortDate()">
          Tgl Mulai
          <!-- <i class="fas fa-sort-numeric-down-alt" v-show="sortMode"></i>
          <i class="fas fa-sort-numeric-up" v-show="!sortMode"></i> -->
        </div>
        <div class="column10 cursor-pointer" @click="sortDate2()">
          Tgl Berakhir
          <!-- <i class="fas fa-sort-numeric-down-alt" v-show="sortMode2"></i
          ><i class="fas fa-sort-numeric-up" v-show="!sortMode2"></i> -->
        </div>
      </div>
      <div v-if="sioData" class="w-full">
        <div
          class="w-full flex-row mb10 text-14"
          v-for="(item, index) in sioData"
          :key="index"
        >
          <!-- <div class="stw-no">
            {{ index + 1 }}
          </div>
          <div class="stw-unit">
            {{ item.bisnis_unit }}
          </div> -->
          <!-- <div class="stw-number col-elipsis all-column">
            {{ item.nomor }}
          </div> -->
          <div class="column40 col-elipsis all-column">
            {{ item.kegiatan }}
          </div>
          <div class="column40 col-elipsis all-column">
            {{ item.area_kerja }}
          </div>
          <!-- <div class="stw-name col-elipsis all-column">
            {{ item.nama_pjo }}
          </div>
          <div class="stw-email col-elipsis all-column">
            {{ item.email_pjo }}
          </div>
          <div class="stw-department col-elipsis all-column">
            {{ item.departemen_pjo }}
          </div> -->
          <div class="column10">
            {{ formatDate(item.start_date) }}
          </div>
          <div class="column10">
            {{ formatDate(item.end_date) }}
          </div>
        </div>
      </div>
      <!-- <div class="st-button-wrapper" v-if="editingStatus && editingUser">
        <div class="st-button-act pointer" @click="addRows()">
          Tambah Baris
        </div>
        <div class="st-button-act" @click="delLastRow()">
              Hapus Baris Terakhir
            </div>
      </div> -->
    </div>

    <div v-if="sioData">
      <div
        v-for="(item, index) in sioData"
        :key="index"
        class="legal-document-wrapper-mobile"
      >
        <div>
          <div>Kegiatan: {{ item.kegiatan }}</div>
        </div>
        <div>
          <div>Area Kerja: {{ item.area_kerja }}</div>
        </div>
        <div>
          Tgl Mulai:
          <span>
            {{ item.start_date ? formatDate(item.start_date) : '-' }}
          </span>
        </div>
        <div>
          Tgl Berakhir:
          <span>
            {{ item.end_date ? formatDate(item.end_date) : '-' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sortMode: false,
      sortMode2: false,
    }
  },
  computed: {
    sioData() {
      return this.$store.state.level1.sioData
    },
    editingStatus() {
      return this.$get(this.$store, 'state.editingStore.sio_level_1.is_open', 0)
    },
    editingUser() {
      return (
        this.$get(this.$store, 'state.editingStore.sio_level_1.user_id', '') ==
        this.$get(this.$store, 'state.userid', 0)
      )
    },
  },
  methods: {
    sortDate() {
      this.sortMode = !this.sortMode
    },
    sortDate2() {
      this.sortMode2 = !this.sortMode2
    },
    addRows() {
      this.$store.commit('modalStore/SHOW_SIO')
    },
    delLastRow() {
      this.sioData.pop()
    },
  },
}
</script>
